import { useTranslation } from 'react-i18next';
import { RepositoryContext } from '../../store/RepositoryProvider';
import { useContext, useEffect, useState } from 'react';
import API from '../../server/api';
import NavBar from '../../components/NavBar';
import List from '../../components/List';
import log from '../../utils/logger';
import Point from '../../models/point/Point';

const Schedule = () => {
  const {t} = useTranslation(['common', 'schedule']);

  const repository = useContext(RepositoryContext);

  const [schedules, setSchedules] = useState([]);
  const [points, setPoints] = useState({});

  const loadSchedules = async () => {
    repository.list(API.cashier.schedules).then((schedules) => {
      let pointMap = schedules.map((s) => s.point).reduce((points, point) => {
        points[point.id] = point;
        return points;
      }, {})
      setSchedules(schedules);
      loadPoints(pointMap);
    }).catch((error) => {
      log.error(error);
      setSchedules([]);
    });
  };

  const loadPoints = async (pointMap) => {
    let filledPoints = {...points};
    for (let pointId in pointMap) {
      repository.getModel(Point.name, pointId).then((model) => {
        if (model.value) {
          filledPoints[model.value.id] = pointMap[model.value.id];
          filledPoints[model.value.id].address = model.value.address;
        }
      });
    }
    setPoints(filledPoints);
  };

  useEffect(() => {
    loadSchedules();
  }, []);

  return (
    <div className="trip-app">
      <NavBar title={t('schedule:schedule.title')} />
      <div className="trip-app-body">
        <List className="schedules">
          {schedules.map((s) => (
            <List.Row key={s.id} className={s.isNow() ? 'selected' : ''}>
              <List.Cell className="align-right">
                <div className="main-line">{s.getDate()}</div>
                <div className="second-line">{t('schedule:schedule.time', {from: s.getTimeFrom(), to: s.getTimeTo()})}</div>
              </List.Cell>
              <List.Cell className="align-left">
                <div className="main-line">{s.point.title}</div>
                <div className="second-line">{points[s.point.id]?.address}</div>
              </List.Cell>
            </List.Row>
          ))}
        </List>
      </div>
    </div>
  )
}

export default Schedule;